<script setup>
import UiModal from '@/Components/UI/UiModal.vue'
import UiButton from '@/Components/UI/UiButton.vue'

defineProps({
  open:        { type: Boolean, required: true },
  title:       { type: String, default: 'Confirm' },
  consequence: { type: String, default: '' },
  message:     { type: String, default: '' },
  confirmText: { type: String, default: 'Confirm' },
  cancelText:  { type: String, default: 'Cancel' },
  danger:      { type: Boolean, default: false },
})
const emit = defineEmits(['confirm', 'cancel'])
</script>

<template>
  <UiModal
    :open="open"
    :title="title"
    :variant="danger ? 'destructive' : 'default'"
    size="sm"
    @close="emit('cancel')"
  >
    <p
      v-if="consequence"
      class="text-sm text-[color:var(--ink)] bg-[color:var(--surfaceAlt)] border border-[color:var(--line)] rounded-[var(--radius-md)] p-3 font-medium"
    >{{ consequence }}</p>
    <p v-else-if="message" class="text-sm text-[color:var(--inkSoft)]">{{ message }}</p>

    <template #footer>
      <UiButton variant="secondary" @click="emit('cancel')">{{ cancelText }}</UiButton>
      <UiButton :variant="danger ? 'danger' : 'primary'" @click="emit('confirm')">{{ confirmText }}</UiButton>
    </template>
  </UiModal>
</template>
